import React from "react";
import { Filters } from "@shopify/polaris";
import { useQuery } from "@apollo/react-hooks";
import { isEmpty, cloneDeep } from "lodash";
import { gql } from "apollo-boost";

import { FilterNoSearchPolaris } from "../../filters/FilterNoSearchPolaris";
import { FilterListRadioPolaris } from "../../filters/FilterListRadioPolaris";
import { STATUS_OPTIONS } from "../../tasks/FilterControlPolaris";
import { FilterTimeByPolaris } from "../../tasks/FilterTimeByPolaris";
import { FilterSortOrderPolaris } from "../FilterSortOrderPolaris";
import { GET_DESIGN_TEAMS, GET_USER_BY_ROLES } from "../../../graphql/queries";
import { TEAM_ROLE } from "../../../variable";
import { FilterHasSearchPolaris } from "../../filters/FilterHasSearchPolaris";

const Need_Review = "Need Review";
const Expired_Soon = "Expired Soon";
const All = "All";
const Doing = "Doing";

const TASK_STATUS = [];
const CLONE_STATUS = cloneDeep([...STATUS_OPTIONS]);
for (let i = 0; i < CLONE_STATUS.length; i++) {
  const item = CLONE_STATUS[i];
  const value = item?.value;
  if (!["All", "Pending Design"].includes(value)) {
    if ([Need_Review].includes(value)) {
      item["value"] = "Need_Review";
      item["label"] = Need_Review;
    }
    if ([Expired_Soon].includes(value)) {
      item["value"] = "Expired_Soon";
      item["label"] = Expired_Soon;
    }
    TASK_STATUS.push(item);
  }
}

const TASK_STATUS2 = [{ value: All, label: All }];
const CLONE_STATUS2 = cloneDeep([...STATUS_OPTIONS]);
for (let i = 0; i < CLONE_STATUS2.length; i++) {
  const item = CLONE_STATUS2[i];
  const value = item?.value;
  if (!["All", "Pending Design"].includes(value)) {
    if ([Need_Review].includes(value)) {
      item["label"] = Need_Review;
      item["label"] = Need_Review;
    }
    if ([Expired_Soon].includes(value)) {
      item["value"] = Expired_Soon;
      item["label"] = Expired_Soon;
    }
    TASK_STATUS2.push(item);
  }
}

const TASK_TYPES = [
  {
    value: All,
    label: All,
  },
  {
    value: "Artist Task",
    label: "Artist Task",
  },
  {
    value: "Design Task",
    label: "Design Task",
  },
  {
    value: "Idea Task",
    label: "Idea Task",
  },
];

export const TEAM_MEMBERS = gql`
  query teamMembers {
    teamMembers(
      filter: {
        limit: 1000
        offset: 0
        search: null
        status: true
        role: "Designer"
      }
    ) {
      hits {
        id
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const ReportFilters = ({ onChange, filter }) => {
  const assigneeId = filter?.userId;
  const statusProp = filter.status;
  const sortStatusProp = filter.sortStatus;
  const orderProp = filter.order;
  const taskTypeProp = filter.taskType;
  const designTeamIDProp = filter.designTeamID;
  // State
  const [search, setSearch] = React.useState(filter?.search || null);
  const [dataDesigner, setDataDesigner] = React.useState([]);
  const [designer, setDesigner] = React.useState({
    value: assigneeId,
    label: null,
    search: null,
  });
  const [sortStatus, setSortStatus] = React.useState({
    value: sortStatusProp || null,
    label: sortStatusProp || null,
  });

  const [status, setStatus] = React.useState({
    value: statusProp || null,
    label: statusProp || null,
  });

  const [taskType, setTaskType] = React.useState({
    value: taskTypeProp || null,
    label: taskTypeProp || null,
  });

  const [designTeams, setDesignTeams] = React.useState([]);
  const [team, setTeam] = React.useState({
    value: assigneeId,
    label: null,
    search: null,
  });

  const [filterTime, setFilterTime] = React.useState({
    range: null,
    rangeLabel: null,
    field: "tasks.created_at",
    fieldLabel: null,
  });
  const [order, setOrder] = React.useState(orderProp);
  // Ref
  const typingTimeoutRef = React.useRef(null);

  // Query
  const {
    data: dataD,
    loading: loadingD,
    error: errorD,
  } = useQuery(GET_USER_BY_ROLES, {
    variables: {
      roles: [
        TEAM_ROLE.Designer,
        TEAM_ROLE.DesignLeader,
        TEAM_ROLE.Idea,
        TEAM_ROLE.IdeaLeader,
        TEAM_ROLE.Artist,
        TEAM_ROLE.ArtistLeader,
      ],
    },
  });

  const {
    data: dataT,
    loading: loadingT,
    error: errorT,
  } = useQuery(GET_DESIGN_TEAMS, {
    variables: {
      filter: {
        limit: 20,
        offset: 0,
        search: team.search || null,
      },
    },
  });

  // Get data
  React.useEffect(() => {
    if (sortStatusProp) {
      let currentS = TASK_STATUS.find((i) => i.value === sortStatusProp);
      if (currentS) {
        setSortStatus({
          value: currentS.value,
          label: currentS.label,
        });
      }
    } else {
      setSortStatus({
        value: Doing,
        label: Doing,
      });
    }
  }, [sortStatusProp]);

  React.useEffect(() => {
    if (statusProp) {
      let currentS = TASK_STATUS2.find((i) => i.value === statusProp);
      if (currentS) {
        setStatus({
          value: currentS.value,
          label: currentS.label,
        });
      }
    } else {
      setStatus({
        value: null,
        label: null,
      });
    }
  }, [statusProp]);

  React.useEffect(() => {
    if (taskTypeProp) {
      let currentS = TASK_TYPES.find((i) => i.value === taskTypeProp);
      if (currentS) {
        setTaskType({
          value: currentS.value,
          label: currentS.label,
        });
      }
    } else {
      setTaskType({
        value: null,
        label: null,
      });
    }
  }, [taskTypeProp]);

  React.useEffect(() => {
    let newData =
      dataD?.listUserTeamByRoles?.length > 0
        ? dataD.listUserTeamByRoles
            .filter((i) => i?.user)
            .filter(Boolean)
            .map(({ user }) => ({
              value: user.id,
              label: `${user.firstName} ${user.lastName}`,
            }))
        : [];
    setDataDesigner(newData);

    if (assigneeId) {
      let currentD =
        newData && newData.length > 0
          ? newData.find((i) => i.value === assigneeId)
          : null;
      if (currentD) {
        setDesigner((prev) => ({
          ...prev,
          label: currentD.label,
          value: currentD.value,
        }));
      }
    }
  }, [dataD, assigneeId]);

  React.useEffect(() => {
    let newData =
      dataT?.getDesignTeams?.nodes?.length > 0
        ? dataT.getDesignTeams.nodes
            .map((item) => {
              if (!item || !item.id) return;

              return {
                value: item.id,
                label: item.name,
              };
            })
            .filter(Boolean)
        : [];
    setDesignTeams([{ value: All, label: All }, ...newData]);

    if (designTeamIDProp) {
      let currentD =
        newData && newData.length > 0
          ? newData.find((i) => i.value === designTeamIDProp)
          : null;
      if (currentD) {
        setTeam((prev) => ({
          ...prev,
          label: currentD.label,
          value: currentD.value,
        }));
      }
    }
  }, [dataT, designTeamIDProp]);

  // Handle action
  React.useEffect(() => {
    typingTimeoutRef.current && clearTimeout(typingTimeoutRef.current);

    const newFieldByTime = { field: filterTime.field };
    if (filterTime?.range?.from) {
      newFieldByTime["from"] = filterTime.range.from;
    }
    if (filterTime?.range?.to) {
      newFieldByTime["to"] = filterTime.range.to;
    }

    typingTimeoutRef.current = setTimeout(() => {
      if (onChange) {
        onChange({
          search: search ? search.trim() : null,
          userId: designer.value,
          sortStatus: sortStatus.value,
          status: status.value,
          taskType: taskType.value === All ? null : taskType.value,
          designTeamID: team.value === All ? null : team.value,
          order,
          fieldByTime:
            Object.keys(newFieldByTime).length > 1
              ? { ...newFieldByTime }
              : null,
        });
      }
    }, 300);
  }, [
    search,
    onChange,
    designer,
    filterTime,
    sortStatus,
    status,
    taskType,
    order,
    team,
  ]);

  const handleSearchChange = React.useCallback((value) => setSearch(value), []);
  const handleFilterTimeRemove = React.useCallback(
    () =>
      setFilterTime(() => ({
        range: null,
        rangeLabel: null,
        field: null,
        fieldLabel: null,
      })),
    [],
  );
  const handleOrderRemove = React.useCallback(() => setOrder(null), []);

  // Remove action
  const handleSearchRemove = React.useCallback(() => setSearch(null), []);
  const handleDesignerRemove = React.useCallback(
    () => setDesigner({ value: null, label: null }),
    [],
  );
  const handleSortStatusRemove = React.useCallback(() => {
    setSortStatus({ value: Doing, label: Doing });
  }, []);

  const handleStatusRemove = React.useCallback(() => {
    setStatus({ value: null, label: null });
  }, []);

  const handleTaskTypeRemove = React.useCallback(() => {
    setTaskType({ value: null, label: null });
  }, []);

  const handleTeamRemove = React.useCallback(() => {
    setTeam({ value: null, label: null });
  }, []);

  const filtersClear = [
    handleSearchRemove,
    handleDesignerRemove,
    handleFilterTimeRemove,
    handleStatusRemove,
    handleSortStatusRemove,
    handleOrderRemove,
    handleTaskTypeRemove,
  ];

  const handleFilterClearAll = React.useCallback(() => {
    for (let fn of filtersClear) {
      fn && fn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...filtersClear]);

  // Markup
  const filters = [
    {
      key: "designer",
      label: "Designer",
      tagLabel: designer.label,
      onRemove: handleDesignerRemove,
      filter: (
        <FilterNoSearchPolaris
          data={dataDesigner}
          value={designer}
          loading={loadingD}
          error={errorD}
          onChange={({ value, label }) =>
            setDesigner((prev) => ({ ...prev, value, label }))
          }
          onChangeSearch={({ search }) =>
            setDesigner((prev) => ({ ...prev, search }))
          }
        />
      ),
    },
    {
      key: "team",
      label: "Team",
      tagLabel: team.label,
      onRemove: handleTeamRemove,
      filter: (
        <FilterHasSearchPolaris
          options={designTeams}
          value={team}
          loading={loadingT}
          error={errorT}
          onChange={({ value, label }) =>
            setTeam((prev) => ({ ...prev, value, label }))
          }
          onChangeSearch={(search) => setTeam((prev) => ({ ...prev, search }))}
        />
      ),
    },
    {
      key: "status",
      label: "Status",
      tagLabel: status.label,
      onRemove: handleStatusRemove,
      filter: (
        <FilterListRadioPolaris
          value={status && status.value}
          options={TASK_STATUS2}
          onChange={({ value, label }) =>
            setStatus((prevState) => ({
              ...prevState,
              value,
              label,
            }))
          }
        />
      ),
    },
    {
      key: "task-type",
      label: "Task Type",
      tagLabel: taskType.label,
      onRemove: handleTaskTypeRemove,
      filter: (
        <FilterListRadioPolaris
          value={taskType && taskType.value}
          options={TASK_TYPES}
          onChange={({ value, label }) =>
            setTaskType((prevState) => ({
              ...prevState,
              value,
              label,
            }))
          }
        />
      ),
    },
    {
      key: "filterTime",
      label: "Filter Time",
      tagLabel: filterTime.rangeLabel,
      onRemove: handleFilterTimeRemove,
      filter: (
        <FilterTimeByPolaris
          filterTime={filterTime}
          isReport
          onChange={(field, fieldLabel) => {
            setFilterTime((filterTime) => ({
              ...filterTime,
              field,
              fieldLabel,
            }));
          }}
          onChangeRange={(range, rangeLabel) => {
            setFilterTime((filterTime) => ({
              ...filterTime,
              range,
              rangeLabel,
            }));
          }}
        />
      ),
    },
    {
      key: "sort-status",
      label: "Sort By Status",
      tagLabel: sortStatus.label,
      onRemove: handleSortStatusRemove,
      filter: (
        <FilterListRadioPolaris
          value={sortStatus && sortStatus.value}
          options={TASK_STATUS}
          onChange={({ value, label }) =>
            setSortStatus((prevState) => ({
              ...prevState,
              value,
              label,
            }))
          }
        />
      ),
    },
    {
      key: "order",
      label: "Order",
      tagLabel: order,
      onRemove: handleOrderRemove,
      filter: (
        <FilterSortOrderPolaris
          order={order}
          onChange={(v) => {
            setOrder(v);
          }}
        />
      ),
    },
  ];

  const appliedFilters = [];
  for (let { key, label, onRemove, tagLabel } of filters) {
    if (key === "filterTime") {
      if (
        (!isEmpty(filterTime.fieldLabel) &&
          "tasks.created_ad" !== filterTime.field) ||
        (!isEmpty(filterTime.rangeLabel) && filterTime.range)
      ) {
        const key = "filterTime";
        let { fieldLabel, rangeLabel, range, field } = filterTime;
        let value = "";
        if (
          null !== fieldLabel &&
          null !== rangeLabel &&
          "Task Created Date" !== fieldLabel
        ) {
          value = `${fieldLabel} & ${rangeLabel}`;
        } else if (
          null !== field &&
          null !== fieldLabel &&
          "Task Created Date" !== fieldLabel
        ) {
          value = `${fieldLabel}`;
        } else if (null !== range) {
          value = `${rangeLabel}`;
        }
        appliedFilters.push({
          key,
          label: disambiguateLabel("Time", value),
          onRemove,
        });
      }
      continue;
    }
    if (!isEmpty(tagLabel) && All !== tagLabel) {
      appliedFilters.push({
        key,
        label: disambiguateLabel(label, tagLabel),
        onRemove,
      });
    }
  }

  return (
    <Filters
      queryValue={search}
      filters={filters}
      appliedFilters={appliedFilters}
      queryPlaceholder="Filter designer"
      onQueryChange={handleSearchChange}
      onQueryClear={handleSearchRemove}
      onClearAll={handleFilterClearAll}
    />
  );
  function disambiguateLabel(label, value) {
    if (!label) {
      return value;
    }
    return `${label}: ${value}`;
  }
};
